<template>
  <div class="page4 full-page">
    <!-- <h4 class="eng page4-shao-ani" v-if="zhoren == 'zh'">
      Customer feedback and legal counsel
    </h4> -->
    <h3 class="page4-shao-ani">{{ $t("page4title") }}</h3>
    <div class="english-slogan" v-if="zhoren == 'zh'">Customer feedback and evaluation</div>
    <!-- <div class="start-get">
      <p class="page4-shao-ani">{{ $t("page4msg") }}</p>
      <router-link tag="a" to="/" class="btn hvr-float-shadow">开启法律咨询</router-link>
      <a class="btn hvr-float-shadow page4-shao-ani" @click="openChat()">{{
        $t("page4btn")
      }}</a>
    </div> -->
    <div class="move-bar">
      <el-carousel arrow="always" :interval="5000">
        <el-carousel-item
          v-for="(item, index) in totalPage"
          :key="index"
          class="init-carousel-box"
          height="600px"
        >
          <div class="overflow">
            <div
              class="item-box"
              v-for="(item2, index2) in 6"
              :key="index + '-' + index2"
            >
              <div class="item-box-bar-header">
                <div class="user-name">
                  <img
                    v-if="commentData[index * 2 + index2].country"
                    :src="
                      $host.file + commentData[index * 2 + index2].country
                        ? $host.file +
                          commentData[index * 2 + index2].country.abb
                        : ''
                    "
                  />
                  <!-- <span v-if="commentData[index * 2 + index2].nick">{{
                    commentData[index * 2 + index2].nick.substring(0, 1) + "..."
                  }}</span> -->
                </div>
                <div class="order-time" v-if="commentData[index * 2 + index2].nick">{{
                  commentData[index * 2 + index2].nick.substring(0, 2) + "..."
                }}</div>
                <!-- <div class="user-vip">
                  {{ commentData[index * 2 + index2].grade }}
                </div> -->
                <div
                  v-if="commentData[index * 2 + index2].inspect_time"
                  class="order-time"
                >
                  <!-- {{commentData[index * 2 + index2].inspect_time.slice(5).replace(/-/g,"月")}}日 -->
                  {{
                    commentData[index * 2 + index2].inspect_time.replace(
                      /-/g,
                      "."
                    )
                  }}
                </div>
                <template v-if="zhoren === 'zh'"
                  ><div class="city">
                    {{ commentData[index * 2 + index2].city }}
                  </div></template
                >
                <template v-else>
                  <div class="city">
                    {{
                      commentData[index * 2 + index2].city_en.length > 2
                        ? commentData[index * 2 + index2].city_en
                        : commentData[index * 2 + index2].city_en.substring(
                            0,
                            2
                          )
                    }}
                  </div>
                </template>

                <div class="type" v-if="commentData[index * 2 + index2].type">
                  {{
                    commentData[index * 2 + index2].type == 1
                      ? $t("user_Index_CJ")
                      : commentData[index * 2 + index2].type == 2
                      ? $t("user_Index_QJ")
                      : commentData[index * 2 + index2].type == 3
                      ? $t("user_Index_ZXJY")
                      : commentData[index * 2 + index2].type == 4
                      ? $t("user_Index_YC")
                      : commentData[index * 2 + index2].type == 5
                      ? $t("user_Index_JG")
                      : $t("user_Index_YH+JG")
                  }}
                </div>
              </div>
              
              <div class="comment-fen">
                <span class="current-rate">{{ $t("page4pingfen") }}:</span>
                <span style="font-size: 10px;font-weight: bold;color: #ef3101;margin-right: 4px;">{{(commentData[index * 2 + index2].score).toFixed(2) || 0.00}}分</span>
                <el-rate
                  style="display: inline-block; vertical-align: middle"
                  :value="commentData[index * 2 + index2].score|| 0"
                  disabled
                  :score-template="(commentData[index * 2 + index2].score).toFixed(2) || 0.00"
                  text-color="#ff9a00"
                  :colors="['#ff9a00']"
                ></el-rate>
                <!-- <span class="fen">{{ $t("user_Index_F") }}</span> -->
              </div>
              <div class="item-box-bar-content">
                {{ commentData[index * 2 + index2].content }}
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- <chat :dialogCat="dialogCat" @close="close" /> -->
  </div>
</template>

<script>
import { comment } from "@/api/webIndex";
// import chat from "@/components/visitorchat.vue"; //聊天
import $ from "jquery";
export default {
  name: "page4",
  components: {
    // chat
  },
  data() {
    return {
      dialogCat: false,
      zhoren: localStorage.getItem("locale") || "zh",
      commentData: [
        {
          content: "242342",
          user_id: 1174,
          inspect_time: "2020-05-15",
          add_time: 1589448936,
          type: "抽检",
          nick: "F1174",
          name: "F1174",
          country: {
            name: "China",
            abb: "/static/flag/CN.png",
            cname: "中国",
            py: null,
          },
          grade: 13,
        },
      ],
      totalPage: 0,
    };
  },
  methods: {
    //打开聊天窗口
    openChat() {
      // this.dialogCat = true;
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
        ? JSON.parse(localStorage.getItem("userInfo"))
        : "";
      let newObj = {};
      if (userInfo) {
        newObj = this.$router.resolve({ path: "/groupchat" });
      } else {
        newObj = this.$router.resolve({ path: "/visitorchat" });
      }
      window.open(newObj.href, "_blank");
    },
    //关闭聊天窗口
    close(val) {
      this.dialogCat = val;
    },
    async getcommentList(val) {
      let res = await comment({
        // page:val+1,
        // page_size:6
      });
      const { data, code } = res.data;
      if (code == 200) {
        let arr = data.concat();
        if (arr.length < 6) {
          this.commentData = arr;
          this.totalPage = 6;
        } else {
          this.commentData = data.slice(
            0,
            parseInt(data.length / 6) * 6
          );
          this.totalPage = parseInt(data.length / 6) * 6;
          this.totalPage = parseInt(data.length / 6) + parseInt(data.length % 6);
        }
        // console.log(this.totalPage )
      }
    },
  },
  created() {},
  async mounted() {
    await this.getcommentList();
  },
  watch: {
    "$route.hash": {
      handler(val) {
        if (this.$route.hash === "#page4") {
          if (!$(".page4-shao-ani").eq(0).hasClass("animated")) {
            $(".page4-shao-ani").css({ visibility: "hidden" });
          }
          setTimeout(function () {
            $(".page4-shao-ani")
              .eq(0)
              .css({ visibility: "visible" })
              .addClass("animated fadeInRightBig");
          }, 1000);
          setTimeout(function () {
            $(".page4-shao-ani")
              .eq(1)
              .css({ visibility: "visible" })
              .addClass("animated fadeInUp");
          }, 1300);
          setTimeout(function () {
            $(".page4-shao-ani")
              .eq(2)
              .css({ visibility: "visible" })
              .addClass("animated fadeInUp");
          }, 1600);
          setTimeout(function () {
            $(".page4-shao-ani")
              .eq(3)
              .css({ visibility: "visible" })
              .addClass("animated fadeInUp");
          }, 1900);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
@media screen and (max-width: 720px) {
  .page4 {
    .move-bar {
      .overflow {
          justify-content: center;
          align-content: center;
        .item-box{
            //  flex:1 0 50%;
        }
      }
    }
  }
}
.page4 /deep/ .el-dialog__wrapper {
  position: absolute;
}
.english-slogan {
  font-size: 18px;
  color: #999999;
  text-align: center;
  font-family:"Times New Roman";
}
$width: 8.21px;
.text-over {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}
.page4 {
  width: 100%;
  // height: 100%;
  // background: url("../../assets/fullpageImage/page4_bg.jpg") no-repeat;
  background-size: cover;
  padding-top: 90px;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;
  h3 {
    font-size: 48px;
    text-align: center;
    color: #000000;
    padding-bottom: 10px;
    box-sizing: border-box;
    position: relative;
    // line-height: 1.5;
    font-family: "黑体";
  }
  h4 {
    text-align: left;
    font-size: 36px / $width * 1vh;
    color: #919090;
  }
  // .start-get {
  //   width: 1200px;
  //   margin: 0 auto;
  //   padding: 40px / $width * 1vh;
  //   margin-top: 30px / $width * 1vh;
  //   text-align: center;
  //   position: relative;
  //   &::before,
  //   &::after {
  //     content: "";
  //     display: block;
  //     width: 45px / $width * 1vh;
  //     height: 45px / $width * 1vh;
  //     border: 4px / $width * 1vh solid #fff;
  //     box-sizing: border-box;
  //     position: absolute;
  //   }
  //   &::before {
  //     left: 0;
  //     top: 0;
  //     border-right: none;
  //     border-bottom: none;
  //   }
  //   &::after {
  //     right: 0;
  //     bottom: 0;
  //     border-left: none;
  //     border-top: none;
  //   }
  //   p {
  //     font-size: 20px;
  //     color: #fafbfd;
  //     font-family: "黑体";
  //     word-break: break-word;
  //   }
  //   .btn {
  //     cursor: pointer;
  //     padding: 0 20px / $width * 1vh;
  //     height: 38px / $width * 1vh;
  //     border-radius: 18px / $width * 1vh;
  //     font-size: 18px / $width * 1vh;
  //     color: #040404;
  //     text-align: center;
  //     line-height: 38px / $width * 1vh;
  //     background-color: #fff;
  //     display: inline-block;
  //     text-decoration: none;
  //     font-family: "黑体";
  //     margin-top: 20px / $width * 1vh;
  //   }
  // }
  .move-bar {
    width: 1330px;
    margin: 30px / $width * 1vh auto 0;
    .item-box {
      // padding: 40px / $width * 1vh 20px / $width * 1vh;
      padding: 20px;
      box-sizing: border-box;
    }
    .item-box-bar-header {
      text-align: left;
      // height: 30px / $width * 1vh;
      padding: 0 44px;
    
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
      & > div {
        display: inline-block;
        vertical-align: middle;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      font-family: "黑体";
      font-size: 0;
      color: #020202;
      .user-name {
        & > img {
          display: inline-block;
          // height: 30px / $width * 1vh;
          width: 45px;
          height: 26px;
          vertical-align: middle;
          margin-right: 6px / $width * 1vh;
        }
        & > span {
          font-size: 18px / $width * 1vh;
          vertical-align: middle;
          max-width: 6vh;
          @extend .text-over;
        }
      }
      .user-vip {
        margin-left: 6px / $width * 1vh;
        width: 30px / $width * 1vh;
        height: 30px / $width * 1vh;
        background-image: url("../../assets/fullpageImage/grade.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        vertical-align: middle;
        font-size: 18px / $width * 1vh;
        line-height: 30px / $width * 1vh;
        text-align: center;
      }
      .order-time {
        // margin-left: 6px / $width * 1vh;
        font-size: 18px;
        font-weight: bold;
        @extend .text-over;
        max-width: 12vh;
      }
      .city {
        margin: 0 8px;
      }
      .city,
      .type {
         font-size: 18px;
        font-weight: bold;
        @extend .text-over;
        max-width: 10vh;
      }
    }
    .comment-fen {
      text-align: center;
      margin-top: 5px;
      // padding-left: 52px;
      .fen {
        color: rgb(113, 113, 113);
        font-size: 14px;
      }
      .current-rate {
        font-size: 14px;
        margin-right: 10px;
        color: #020202;
      }
      /deep/ .el-rate__icon {
        color: #ef3101;
      }
    }

    .item-box-bar-content {
      font-size: 14px / $width * 1vh;
      line-height: 26px / $width * 1vh;
      color: #020202;
      margin-top: 5px / $width * 1vh;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      border-top: 1px solid #cecece;
      padding: 8px 0 10px 0;
    }
    /deep/ .init-carousel-box {
      box-sizing: border-box;
      overflow: hidden;
    }
    .overflow {
      box-sizing: border-box;
      // padding: 0 100px / $width * 1vh 0 105px / $width * 1vh;
      width: 100%;
      display: flex;
      // justify-content: flex-start;
      // align-items: center;
      flex-wrap: wrap;
      // height: 100%;
    }
    /deep/ .el-carousel__container {
      height: 560px;
    }
    /deep/ .el-carousel__button {
      background-color: #cecece;
      width: 10px;
      height: 10px;
      border-radius: 50%;;
    }
    /deep/ .el-carousel__indicator.is-active button {
      background-color: #fe4f1e;
    }
    .item-box {
      flex: 1 0 26%;
      background-color: #f1f1f1;
      // height: 50%;
      height: 240px;
      overflow: hidden;
      &:nth-of-type(3n+1) {
        margin-bottom: 16px;
      }
      &:not(:nth-of-type(3n)) {
        margin-right: 16px;
      }
      // &:nth-of-type(1),
      // &:nth-of-type(2),
      // &:nth-of-type(3) {
      //   margin-bottom: 20px / $width * 1vh;
      // }
    }
    /deep/ .el-carousel__arrow--right {
      display: none;
    }
    /deep/ .el-carousel__arrow--left {
      display: none;
    }
    /deep/ .el-carousel__arrow:hover,
    /deep/ .el-carousel__arrow {
      background-color: transparent;
    }
    // /deep/ .el-carousel__arrow--right:hover,
    // /deep/ .el-carousel__arrow--left:hover {
    //   color: #fff;
    // }
    // /deep/ .el-carousel__arrow i {
    //   font-size: 90px;
    //   position: relative;
    //   top: -30px / $width * 1vh;
    // }
  }
}
@media screen and(min-width:1920px) {
  .page4 {
    .move-bar,
    .start-get {
      width: 1600px;
    }
  }
}
@media screen and (max-width: 720px) {
  .page4 {
    h3 {
      font-size: 40px / $width * 1vh;
      &:after,
      &:before {
        content: "";
        display: block;
        position: absolute;
        height: 7px / $width * 1vh;
        background-color: #f16a14;
        border-radius: 3px / $width * 1vh;
      }
      &:after {
        width: 168px / $width * 1vh;
        bottom: 0;
        left: 0;
      }
      &:before {
        width: 44px / $width * 1vh;
        bottom: 0;
        left: (168px + 23px) / $width * 1vh;
      }
    }
    .move-bar,
    .start-get {
      width: 100%;
    }
  }
}
</style>
